import { render, staticRenderFns } from "./CloudCustomer.vue?vue&type=template&id=b02f08fe&"
import script from "./CloudCustomer.vue?vue&type=script&lang=js&"
export * from "./CloudCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports